"use client"

import { BlockRenderer, TopBanner } from "ui"
import { findProperty, getBreadCrumbs } from "utils"
import ConcreteProcessStep from "./ConcreteProcessStep"

type Props = {
  data: any
  locale: string
}
function ProductionProcess({ data, locale }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)

  const components = {
    topBanner2: TopBanner,
    concreteProcessStep: ConcreteProcessStep,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  return (
    <>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "topBanner2") {
          additionalProps = {
            isFullHeight: false,
            imageHeight: "300px",
            titleFontWeight: 600,
          }
        }
        if (block.blockType === "concreteProcessStep") {
          additionalProps = { selfObject, parents }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            props={additionalProps}
          />
        )
      })}
    </>
  )
}
export default ProductionProcess
